import { render, staticRenderFns } from "./AsideSegments.vue?vue&type=template&id=01571aaa&"
import script from "./AsideSegments.vue?vue&type=script&lang=js&"
export * from "./AsideSegments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports